import {
  Box,
  Typography,
  CircularProgress,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
} from '@mui/material';
import React, { useState, useEffect } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FlyoutContainer from './FlyoutContainer';
import {
  FIND_ALL_PLACES_OF_SERVICE,
  FIND_MODIFIERS_WITH_PLACE_OF_SERVICES,
  GET_MODIFIER_DETAILS,
} from '../../services/PriceTransparencyQueries/PriceTransparencyService';
import { useLazyQuery } from '@apollo/client';
import moment from 'moment';
import { getAffiliateFromDomain } from '../../shared/helper';
import ServiceFlyoutDropdown from './ServiceFlyoutDropdown';

export const PriceListFlyout = ({
  serviceName,
  billingCode,
  providersNpi,
  codingSystemVersion,
  entityName,
  entityType,
  expirationDate,
  lastUpdatedOn,
  negotiatedArrangement,
  planIdType,
  planName,
  planId,
  derivedTin,
  negotiatedType,
  handleClose,
  isOpen,
  modifier,
  setModifier,
  modifierMenu,
  setModifierMenu,
  tabValue,
}) => {
  const [tin, setTin] = useState();
  const [modifierArray, setModifierArray] = useState([]);
  const [rateData, setRateData] = useState([]);
  const [accordionExpanded, setAccordionExpanded] = useState(false);
  const [negRateBillingClass, setNegRateBillingClass] =
    useState('PROFESSIONAL');

  const modifierFilterOptions = {
    options: modifierMenu,
    value: modifier === '' ? 'Others' : modifier,
    changeHandler: ev => {
      setModifier(ev.target.value);
    },
  };

  const handleAccordionExpandChange = () => {
    setAccordionExpanded(!accordionExpanded);
    setModifier(null);
  };

  const handleFlyoutClose = () => {
    setAccordionExpanded(false);
    setTin();
    handleClose();
  };

  const handleNegRateUI = rate => {
    let values = rate.split(' ');
    let result = '';
    if (values.length === 3) {
      let min = Math.abs(values[0]);
      let max = Math.abs(values[2]);
      if (min === max) {
        return `$${min}`;
      } else {
        return `$${min} - $${max}`;
      }
    } else if (values.length === 1) {
      result += `$${Math.abs(values[0])}`;
    } else {
      return `$${rate}`;
    }

    return result;
  };

  const [findAllPlacesOfServices, { loading: placeServiceLoading }] =
    useLazyQuery(FIND_ALL_PLACES_OF_SERVICE, {
      onCompleted: res => {
        setTin(res.findAllPlacesOfServices.tin);
      },
    });

  const [findAllModifiers, { loading: NegRateModifierLoading }] = useLazyQuery(
    FIND_MODIFIERS_WITH_PLACE_OF_SERVICES,
    {
      onCompleted: res => {
        setModifierArray(res.findDetailsByBillingCodeAndNpiCode);
        if (res.findDetailsByBillingCodeAndNpiCode?.length === 0) {
          setModifierMenu([]);
        }
        let codeArray = [];
        for (let item of res.findDetailsByBillingCodeAndNpiCode) {
          if (item.modifier === '') {
            setModifierMenu([{ label: 'Others', value: 'Others' }]);
          }
          codeArray.push(item.modifier);
        }
        if (codeArray.length !== 0) {
          findModifierDetails({
            variables: {
              reqbody: {
                codeList: codeArray,
              },
            },
          });
        }
      },
    }
  );

  const [findModifierDetails, { loading: NegRateModifierDetailsLoading }] =
    useLazyQuery(GET_MODIFIER_DETAILS, {
      onCompleted: res => {
        let menu = [];
        for (let item of res.findAllModifiers) {
          menu.push({
            label: `${item.description} (${item.code})`,
            value: item.code,
          });
        }
        setModifierMenu(prev => [...prev, ...menu]);
      },
    });

  const handleBillingClassChange = value => {
    {
      setModifier(null);
      setNegRateBillingClass(value);
      findAllModifiers({
        variables: {
          reqbody: {
            network: getAffiliateFromDomain(),
            billingCode: billingCode,
            providersNpi: providersNpi,
            priceCategory: tabValue == 1 ? 'IN' : 'OUT',
            billingClass: value,
          },
        },
      });
    }
  };

  useEffect(() => {
    if (tabValue == 1) {
      findAllPlacesOfServices({
        variables: {
          reqdata: {
            planId: Number(planId),
            billingCode: billingCode,
            providersNpi: providersNpi,
            negotiatedType: negotiatedType,
          },
        },
      });
    }
  }, [billingCode, providersNpi, negotiatedType, planId, tabValue]);

  useEffect(() => {
    if (modifier == null) {
      setRateData([]);
    } else if (modifier == 'Others') {
      let selectedObject = modifierArray.filter(item => item.modifier === '');
      setRateData(selectedObject[0]?.serviceCodes);
    } else {
      let selectedObject = modifierArray.filter(
        item => item.modifier === modifier
      );
      setRateData(selectedObject[0]?.serviceCodes);
    }
  }, [modifier]);

  useEffect(() => {
    if (accordionExpanded && tabValue == 1) {
      setNegRateBillingClass('PROFESSIONAL');
      findAllModifiers({
        variables: {
          reqbody: {
            network: getAffiliateFromDomain(),
            billingCode: billingCode,
            providersNpi: providersNpi,
            priceCategory: 'IN',
            billingClass: 'PROFESSIONAL',
          },
        },
      });
    } else if (accordionExpanded && tabValue == 2) {
      setNegRateBillingClass('PROFESSIONAL');
      findAllModifiers({
        variables: {
          reqbody: {
            network: getAffiliateFromDomain(),
            billingCode: billingCode,
            providersNpi: providersNpi,
            priceCategory: 'OUT',
            billingClass: 'PROFESSIONAL',
          },
        },
      });
    }
  }, [accordionExpanded]);

  return (
    <FlyoutContainer isOpen={isOpen} handleClose={handleFlyoutClose}>
      {placeServiceLoading ? (
        <Box
          sx={{
            display: 'flex',
            height: '80vh',
            justifyContent: 'center',
            alignItems: 'center',
          }}>
          <CircularProgress />
        </Box>
      ) : (
        <Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              paddingRight: '10px',
            }}>
            {
              <Typography
                variant="title"
                style={{ textTransform: 'capitalize' }}>
                {serviceName || null}
              </Typography>
            }
            {
              <Typography variant="h6">
                Service code: {billingCode || null}
              </Typography>
            }
          </Box>

          <Box
            sx={{
              margin: '24px 0',
              padding: '20px',
              borderRadius: '4px',
              backgroundColor: '#F5F7F8',
              border: '1px solid #E4E7EC',
              boxShadow: 'none',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
            }}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                flexWrap: 'wrap',
                justifyContent: 'space-between',
              }}>
              <Box sx={{ marginBottom: '20px' }}>
                <Typography sx={{ color: '#667085' }}>Plan ID</Typography>
                <Typography>{planId}</Typography>
              </Box>
              <Box sx={{ marginBottom: '20px' }}>
                <Typography sx={{ color: '#667085' }}>Plan name</Typography>
                <Typography>{planName}</Typography>
              </Box>
              {tabValue == 1 && (
                <Box sx={{ marginBottom: '20px' }}>
                  <Typography sx={{ color: '#667085' }}>
                    Plan ID type
                  </Typography>
                  <Typography>{planIdType}</Typography>
                </Box>
              )}
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                flexWrap: 'wrap',
                justifyContent: 'space-between',
              }}>
              <Box sx={{ marginBottom: '20px' }}>
                <Typography sx={{ color: '#667085' }}>Entity Name</Typography>
                <Typography>{entityName ? entityName : '-'}</Typography>
              </Box>
              <Box sx={{ marginBottom: '20px' }}>
                <Typography sx={{ color: '#667085' }}>Entity Type</Typography>
                <Typography>{entityType ? entityType : '-'}</Typography>
              </Box>
              {tabValue == 1 && (
                <Box sx={{ marginBottom: '20px' }}>
                  <Typography sx={{ color: '#667085' }}>TIN</Typography>
                  <Typography>{tin}</Typography>
                </Box>
              )}
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                flexWrap: 'wrap',
                justifyContent: 'space-between',
              }}>
              <Box sx={{ marginBottom: '20px' }}>
                <Typography sx={{ color: '#667085' }}>
                  {tabValue == 1 ? 'Expiration Date' : 'Plan ID type'}
                </Typography>
                <Typography>
                  {tabValue == 1
                    ? moment(expirationDate).format('MM-DD-YYYY')
                    : planIdType}
                </Typography>
              </Box>
              <Box sx={{ marginBottom: '20px' }}>
                <Typography sx={{ color: '#667085' }}>
                  {tabValue == 1 ? 'Last Updated On' : 'TIN'}
                </Typography>
                <Typography>
                  {tabValue == 1 
                    ? moment(lastUpdatedOn).format('MM-DD-YYYY') 
                    : derivedTin}
                </Typography>
              </Box>
              {tabValue == 1 && (
                <Box sx={{ marginBottom: '20px' }}>
                  <Typography sx={{ color: '#667085' }}>
                    Negotiated Type
                  </Typography>
                  <Typography>{negotiatedType}</Typography>
                </Box>
              )}
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                flexWrap: 'wrap',
              }}>
              <Box sx={{ marginBottom: '20px' }}>
                <Typography sx={{ color: '#667085' }}>
                  {tabValue == 1
                    ? 'Negotiated Arrangement'
                    : 'Coding System Version'}
                </Typography>
                <Typography>
                  {tabValue == 1 ? negotiatedArrangement : codingSystemVersion}
                </Typography>
              </Box>
              {tabValue == 1 && (
                <Box sx={{ marginBottom: '20px' }}>
                  <Typography sx={{ color: '#667085' }}>
                    Coding System Version
                  </Typography>
                  <Typography>{codingSystemVersion}</Typography>
                </Box>
              )}
            </Box>
          </Box>

          {tabValue == 1 && (
            <Box
              sx={{
                margin: '24px 0',
                borderRadius: '8px',
              }}>
              <Accordion
                sx={{
                  borderRadius: '8px',
                  backgroundColor: '#F5F7F8',
                  border: '1px solid #E4E7EC',
                  boxShadow: 'none',
                  margin: '24px 0',
                  '&::before': {
                    backgroundColor: 'transparent',
                  },
                }}
                expanded={accordionExpanded}
                onChange={handleAccordionExpandChange}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="navSelected">
                    Negotiated rate based on modifier and place of service
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  {NegRateModifierLoading || NegRateModifierDetailsLoading ? (
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}>
                      <CircularProgress size={'30px'} />
                    </Box>
                  ) : (
                    <Box>
                      <FormControl sx={{ mt: '10px' }}>
                        <RadioGroup
                          row
                          value={negRateBillingClass}
                          onChange={e =>
                            handleBillingClassChange(e.target.value)
                          }>
                          <FormControlLabel
                            value="PROFESSIONAL"
                            control={<Radio />}
                            label="Professional"
                          />
                          <FormControlLabel
                            value="INSTITUTIONAL"
                            control={<Radio />}
                            label="Institutional"
                          />
                        </RadioGroup>
                      </FormControl>

                      {modifierFilterOptions.options?.length !== 0 ? (
                        <Box>
                          <Typography
                            sx={{
                              mt: '24px',
                              fontWeight: '500',

                              color: '#344054',
                            }}>
                            Select modifier
                          </Typography>
                          <Box sx={{ display: 'flex', flexWrap: 'wrap',width:"100%" }}>
                            <ServiceFlyoutDropdown {...modifierFilterOptions} />
                          </Box>
                        </Box>
                      ) : (
                        <Typography
                          sx={{
                            mt: '24px',
                            fontWeight: '400px',
                            fontSize: '14px',
                          }}>
                          {`No prices found for ${
                            negRateBillingClass[0]?.toUpperCase() +
                            negRateBillingClass?.slice(1)?.toLowerCase()
                          }`}
                        </Typography>
                      )}

                      {rateData.length === 0 && modifier && (
                        <Typography
                          sx={{
                            mt: '24px',
                            fontWeight: '400px',
                            fontSize: '14px',
                          }}>
                          No Data available for the selected modifier
                        </Typography>
                      )}

                      {rateData.length !== 0 && (
                        <Box
                          sx={{
                            margin: '24px 0',
                            borderRadius: '16px',
                            backgroundColor: '#FFFFFF',
                            boxShadow: 'none',
                            p: '16px',
                            width: '100%',
                            maxWidth: '690px',
                          }}>
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'space-between',
                            }}>
                            <Typography
                              sx={{ fontWeight: 600, fontSize: '14px' }}>
                              Place of service
                            </Typography>
                            <Typography
                              sx={{ fontWeight: 600, fontSize: '14px' }}>
                              Negotiated rate
                            </Typography>
                          </Box>
                          <hr style={{ border: '0.5px solid #E4E7EC' }} />
                          {rateData?.map((val, index, arr) => (
                            <Box
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                ...(index !== arr.length - 1 && {
                                  borderBottom: '1px solid #E4E7EC',
                                }),
                              }}>
                              <Box
                                component="span"
                                sx={{ p: '14px 14px 14px 0px', flex: '1' }}>
                                {val?.placeOfService || 'Others'}
                              </Box>
                              <Box
                                component="span"
                                sx={{
                                  p: '14px 14px 14px 0px',
                                  flexBasis: '105px',
                                }}>
                                {handleNegRateUI(val?.negotiatedRate)}
                              </Box>
                            </Box>
                          ))}
                        </Box>
                      )}
                    </Box>
                  )}
                </AccordionDetails>
              </Accordion>
            </Box>
          )}

          {tabValue == 2 && (
            <Box
              sx={{
                margin: '24px 0',
                borderRadius: '8px',
              }}>
              <Accordion
                sx={{
                  borderRadius: '8px',
                  backgroundColor: '#F5F7F8',
                  border: '1px solid #E4E7EC',
                  boxShadow: 'none',
                  margin: '24px 0',
                  '&::before': {
                    backgroundColor: 'transparent',
                  },
                }}
                expanded={accordionExpanded}
                onChange={handleAccordionExpandChange}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography sx={{ fontSize: '18px' }} variant="navSelected">
                    Allowed amount based on modifier and place of service
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography
                    sx={{
                      fontSize: '14px',
                      fontWeight: '400',
                      display: 'block',
                      marginTop: '-20px',
                    }}
                    variant="navSelected">
                    Please check if you are in-network for this service with
                    your plan and provider
                  </Typography>
                  {NegRateModifierLoading || NegRateModifierDetailsLoading ? (
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}>
                      <CircularProgress size={'30px'} />
                    </Box>
                  ) : (
                    <Box>
                      <FormControl sx={{ mt: '10px' }}>
                        <RadioGroup
                          row
                          value={negRateBillingClass}
                          onChange={e =>
                            handleBillingClassChange(e.target.value)
                          }>
                          <FormControlLabel
                            value="PROFESSIONAL"
                            control={<Radio />}
                            label="Professional"
                          />
                          <FormControlLabel
                            value="INSTITUTIONAL"
                            control={<Radio />}
                            label="Institutional"
                          />
                        </RadioGroup>
                      </FormControl>

                      {modifierFilterOptions.options?.length !== 0 ? (
                        <Box>
                          <Typography
                            sx={{
                              mt: '24px',
                              fontWeight: '500',

                              color: '#344054',
                            }}>
                            Select modifier
                          </Typography>
                          <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                            <ServiceFlyoutDropdown {...modifierFilterOptions} />
                          </Box>
                        </Box>
                      ) : (
                        <Typography
                          sx={{
                            mt: '24px',
                            fontWeight: '400px',
                            fontSize: '14px',
                          }}>
                          {`No prices found for ${
                            negRateBillingClass[0]?.toUpperCase() +
                            negRateBillingClass?.slice(1)?.toLowerCase()
                          }`}
                        </Typography>
                      )}

                      {modifier && rateData.length === 0 && (
                        <Typography
                          sx={{
                            mt: '24px',
                            fontWeight: '400px',
                            fontSize: '14px',
                          }}>
                          No Data available for the selected modifier
                        </Typography>
                      )}

                      {rateData.length !== 0 && (
                        <Box
                          sx={{
                            margin: '24px 0',
                            borderRadius: '16px',
                            backgroundColor: '#FFFFFF',
                            boxShadow: 'none',
                            p: '16px',
                            width: '100%',
                            maxWidth: '690px',
                          }}>
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'space-between',
                            }}>
                            <Typography
                              sx={{ fontWeight: 600, fontSize: '14px' }}>
                              Place of service
                            </Typography>
                            <Typography
                              sx={{ fontWeight: 600, fontSize: '14px' }}>
                              Negotiated rate
                            </Typography>
                          </Box>
                          <hr style={{ border: '1px solid #E4E7EC' }} />
                          {rateData?.map((val, index, arr) => (
                            <Box
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                ...(index !== arr.length - 1 && {
                                  borderBottom: '1px solid #E4E7EC',
                                }),
                              }}>
                              <Box
                                component="span"
                                sx={{ p: '14px 14px 14px 0px', flex: '1' }}>
                                {val?.placeOfService || 'Others'}
                              </Box>
                              <Box
                                component="span"
                                sx={{
                                  p: '14px 14px 14px 0px',
                                  flexBasis: '105px',
                                }}>
                                {handleNegRateUI(val?.negotiatedRate)}
                              </Box>
                            </Box>
                          ))}
                        </Box>
                      )}
                    </Box>
                  )}
                </AccordionDetails>
              </Accordion>
            </Box>
          )}
        </Box>
      )}
    </FlyoutContainer>
  );
};

export default PriceListFlyout;
